var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import { removeProfileSessionAction } from "../helpers/profileSessionStorage";
// This is only use to create ProfileGlobalContext
export var mockProfileGlobalStore = {
    state: {
        selectedAccountId: "",
        shouldEditProfile: false,
        didEditMutationSucceeded: false,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch: function (_newState) {
        throw new Error("No dispatch");
    },
    goToShowProfile: function () {
        throw new Error("No goToShowProfile");
    },
};
var ProfileGlobalContext = createContext(mockProfileGlobalStore);
ProfileGlobalContext.displayName = "Profile Global Context";
export var useProfileGlobalState = function () {
    var value = useContext(ProfileGlobalContext);
    if (!value) {
        throw new Error("No Profile context value");
    }
    return value;
};
var ProfileGlobalContextProvider = function (_a) {
    var _b;
    var initialState = _a.initialState, children = _a.children;
    // Setting up Initial State
    var _c = useState(__assign({ selectedAccountId: (_b = sessionStorage.getItem("selectedAccountId")) !== null && _b !== void 0 ? _b : "", shouldEditProfile: false, didEditMutationSucceeded: false }, initialState)), state = _c[0], setState = _c[1];
    var dispatch = useCallback(function (newState) {
        setState(function (prevState) { return (__assign(__assign({}, prevState), newState)); });
    }, []);
    var goToShowProfile = function () {
        dispatch({ shouldEditProfile: false });
        removeProfileSessionAction();
    };
    var contextValue = useMemo(function () { return ({ state: state, dispatch: dispatch, goToShowProfile: goToShowProfile }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    return (_jsx(ProfileGlobalContext.Provider, __assign({ value: contextValue }, { children: children })));
};
export default ProfileGlobalContextProvider;
